import React from "react";
import {useEffectTransition, OverlayUnderpanel, transitions, useDynamicPanels, tailCheck} from "./CommonReact";


export const useSidePanel = () => useDynamicPanels(({panelId, ...props}) => <SidePanel key={panelId} {...props}/>);


function SidePanel({Elm, hide, className, transition = transitions.slideLeft, classNameOverlay, onClose, ...props}) {
    const {classNameTrans, propsTrans, refTrans} = useEffectTransition({transition, isShown: !hide});

    return <OverlayUnderpanel {...{classNameTrans, classNameOverlay, onClose}}>
        {() =>
            <div className={tailCheck(className, "w-56", classNameTrans)}
                 style={{position: "fixed", zIndex: 40}}
                 {...propsTrans} ref={refTrans}>
                <Elm {...{onClose, ...props}}/>
            </div>
        }
    </OverlayUnderpanel>;
}
